"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var config;

function setConfig(_) {
  if (_ == null) {
    config = {};
  } else {
    config = _;
  }
}

exports.setConfig = setConfig;

function getConfig() {
  return config;
}

exports.getConfig = getConfig;